/** Canonical Canvas node Dropdown — same transform-aware reposition contract
 * as `CanvasSelect` (TASK-00050). */
import { Dropdown, type DropdownProps } from 'antd'
import { useState } from 'react'
import { useCanvasAnchoredOverlayOpen } from './canvasAnchoredOverlay'

export type CanvasDropdownProps = DropdownProps

export default function CanvasDropdown({
  open: openProp,
  onOpenChange,
  getPopupContainer,
  ...rest
}: CanvasDropdownProps) {
  const [uncontrolledOpen, setUncontrolledOpen] = useState(false)
  const open = openProp ?? uncontrolledOpen

  useCanvasAnchoredOverlayOpen(Boolean(open))

  const handleOpenChange = (nextOpen: boolean, info: Parameters<NonNullable<DropdownProps['onOpenChange']>>[1]) => {
    onOpenChange?.(nextOpen, info)
    if (openProp === undefined) setUncontrolledOpen(nextOpen)
  }

  return (
    <Dropdown
      {...rest}
      open={openProp}
      onOpenChange={handleOpenChange}
      getPopupContainer={getPopupContainer ?? (() => document.body)}
    />
  )
}
